import { computed, observable } from 'mobx';
import {ChannelSchema} from '../../../types/schema';

export class AccountChannelsPageModel {
  @observable
  loading: boolean = false;

  @observable
  channels: Array<ChannelSchema> = [];
}